import type { User } from "@supabase/supabase-js"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"
import { GlobalError } from "@/components/shared/errors/global-error"
import { NotFound } from "@/components/shared/errors/not-found"
import { Toaster } from "@/components/shared/toast"
import { DEFAULT_STALE_TIME } from "@/lib/constants"

export interface RouterContext {
	auth: User | null
	queryClient: QueryClient
}

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: DEFAULT_STALE_TIME,
			refetchOnWindowFocus: false,
		},
	},
})

export const Route = createRootRouteWithContext<RouterContext>()({
	component: RootLayout,
	notFoundComponent: NotFound,
	errorComponent: GlobalError,
})

function RootLayout() {
	return (
		<QueryClientProvider client={queryClient}>
			<Outlet />
			<Toaster />
		</QueryClientProvider>
	)
}
